import { Box, Button, Center, Heading, Text } from '@chakra-ui/react';
import * as React from 'react';

import { Card as BaseCard } from '@/imports/ui/chakra/components/Card';
import { Emoji } from '@/imports/ui/chakra/components/Emoji';

import { useCreateUpgradeRequest } from './useCreateUpgradeRequest';

export const Card: React.FC<{
  canViewContent: boolean;
  organizationId: string;
  headerText: string;
  bodyText: string;
  shouldShowUpgradeCTA: boolean;
  source: string;
  hideCTAButtons?: boolean;
  children: any;
}> = ({
  canViewContent,
  organizationId,
  headerText,
  bodyText,
  shouldShowUpgradeCTA = true,
  source,
  hideCTAButtons = false,
  children,
}) => {
  const { requestOrganizationUpgrade, loading, submittedUpgrade } =
    useCreateUpgradeRequest(organizationId);

  const handleClick = async (buttonText: string): Promise<void> => {
    await requestOrganizationUpgrade(`${source}: "${buttonText}" button`);
  };

  if (canViewContent) {
    return children;
  }

  return (
    <Box position="relative">
      <Box style={{ filter: 'blur(4px)' }}>{children}</Box>

      <Center position="absolute" top="0" right="0" bottom="0" left="0">
        <BaseCard w="lg" p="6">
          <Box textAlign="center">
            {!hideCTAButtons && (
              <>
                <Emoji
                  label={submittedUpgrade ? 'check mark' : 'old key'}
                  symbol={submittedUpgrade ? '✅' : '🗝️'}
                  fontSize="4xl"
                  lineHeight="normal"
                />

                <Heading as="h4" size="md" mt="5">
                  {submittedUpgrade ? 'We’ll Be in Touch Soon!' : headerText}
                </Heading>
              </>
            )}

            <Text color="gray.500" mt="2" mb="6">
              {hideCTAButtons
                ? 'The free sponsorship tier does not include the ability to view and download lead contact information'
                : submittedUpgrade
                ? `Our team has been notified of your interest and someone will be in touch with you soon!`
                : bodyText}
            </Text>
          </Box>

          {!hideCTAButtons && !submittedUpgrade && shouldShowUpgradeCTA && (
            <Center>
              <Button
                colorScheme="gray"
                variant="outline"
                mr="4"
                isLoading={loading}
                onClick={() => handleClick('Contact us to learn more')}
              >
                Contact Us to Learn More
              </Button>

              <Button
                isLoading={loading}
                onClick={() => handleClick('Upgrade now')}
              >
                Upgrade Now
              </Button>
            </Center>
          )}
        </BaseCard>
      </Center>
    </Box>
  );
};
